/**
 * represent a Visible State
 */
export enum ApVisibleStates {
  IN = 'in',
  OUT = 'out'
}
